import React from 'react';
import AppRoutes from '@/router/appRoutes';
import { Footer } from '@/components/general/Footer';
import { Header } from '@/components/general/Header';
import WhatsAppFloat from '@/components/general/WhatsAppFloat';
import '@/App.css';
import '@/style/main.scss';

function App() {
  return (
    <div className="program-page-root">
      <Header />
      <AppRoutes />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
